import React, { useEffect } from 'react';
import classNames from 'classnames';

import AIVoiceAdvancedFilters from './AIVoiceAdvancedFilters';
import AIVoiceSearch from './AIVoiceSearch';

import type { AIVoice } from 'js/src/client';
import AIVoiceBasicFilters from 'js/src/components/app/VoiceSelectionModal/AIVoiceBasicFilters';
import AIVoiceSort from 'js/src/components/app/VoiceSelectionModal/AIVoiceSort';
import useAIVoiceFilters from 'js/src/components/app/VoiceSelectionModal/useAIVoiceFilters';
import Tooltip, { Placement } from 'js/src/components/common/ui/Tooltip';

interface VoiceSelectionModalSearchProps {
    className?: string;
    selectedVoice?: AIVoice | null;
}

const VoiceSelectionModalSearch: React.FC<VoiceSelectionModalSearchProps> = ({
    className,
    selectedVoice = null,
}) => {
    const { isUninitialized, triggerFetch } = useAIVoiceFilters();

    useEffect(() => {
        if (!isUninitialized) {
            return;
        }
        triggerFetch();
    }, [isUninitialized, triggerFetch]);

    return (
        <div className={classNames('container-fluid', className)}>
            <div className="row gx-2">
                <AIVoiceSearch className="col" />
                <AIVoiceBasicFilters className="col-auto" />
                <AIVoiceSort className="col-auto" />
                <div className="col-12 mt-l5-8 d-flex align-items-center">
                    <AIVoiceAdvancedFilters className="col-9" />
                    {selectedVoice && (
                        <Tooltip
                            title={selectedVoice.display_name}
                            trigger="hover"
                            placement={Placement.TOP}
                        >
                            <div className="col-3 ms-l5-auto text-truncate text-end">
                                <span className="font-l5 font-l5--small color-grey-600">
                                    Current voice:{' '}
                                    <strong className="font-l5 font-l5--small--semibold color-grey-900">
                                        {selectedVoice.display_name}
                                    </strong>
                                </span>
                            </div>
                        </Tooltip>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VoiceSelectionModalSearch;
